import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Table, Loader, Message, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import Header from './header';
import Fields from './fields';
import './comboTasks.scss';

const {clearComboTasksPage, addComboTask} = Actions;

const LoaderOrFields = ({tasks, loadingTasks, loadingCandidateTasks,
  submitting, deleting,
}) => {
  if (loadingTasks || loadingCandidateTasks) {
    return (
      <Card raised fluid>
        <Loader active inline='centered'>
          Obteniendo Información...
        </Loader>
      </Card>
    );
  }

  if (submitting || deleting) {
    return (
      <Card raised fluid>
        <Loader active inline='centered'>
          Procesando...
        </Loader>
      </Card>
    );
  }

  return (
    <Card raised fluid className='combo-tasks-fields'>
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Tareas</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Fields tasks={tasks} />
      </Table>
    </Card>
  );
};

const FieldsActions = ({searchedTasks, selectedCombo, adding, loadingCandidateTasks,
  loadingTasks, candidateTasks, dispatch,
}) => {
  if (!searchedTasks || !selectedCombo || adding ||
    loadingCandidateTasks || loadingTasks
  ) {
    return null;
  }

  if (searchedTasks && !candidateTasks.length) {
    return (
      <Message info>
        No se encontraron tareas para el combo seleccionado.
      </Message>
    );
  }

  return (
    <div className='addItem' onClick={() => dispatch(addComboTask())}>
      <Icon name='add' />
      <strong>AGREGAR REGISTRO</strong>
    </div>
  );
};

const ComboTasks = () => {
  const comboTasks = useSelector((state) => state.comboTasks);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearComboTasksPage());
  }, [dispatch]);

  const {tasks, loadingTasks, loadingCandidateTasks, submitting, deleting, searchedTasks,
    selectedCombo, adding, candidateTasks} = comboTasks;

  return (
    <div className='combo-tasks'>
      <Header />
      <LoaderOrFields
        tasks={tasks}
        loadingTasks={loadingTasks}
        loadingCandidateTasks={loadingCandidateTasks}
        submitting={submitting}
        deleting={deleting}
      />
      <FieldsActions
        searchedTasks={searchedTasks}
        selectedCombo={selectedCombo}
        adding={adding}
        loadingCandidateTasks={loadingCandidateTasks}
        loadingTasks={loadingTasks}
        candidateTasks={candidateTasks}
        dispatch={dispatch}
      />
    </div>
  );
};

export default ComboTasks;
